export default __webpack_public_path__ + "static/design-buddies-8d249072a1e427d150ed7ef0362d43df.svg";